<template>
  <div class="container offset pb-2">
    <form @submit.prevent="createMember">
      <div class="custom-form">
        <img
          class="image-style"
          src="../../assets/img/Dados/ListarMembros/icon-add-user.png"
        />

        <div class="form-group">
          <label class="question-style">E-mail:</label>
          <input
            @input="verifyValidadeEmail()"
            v-model="email"
            type="email"
            class="form-control"
            placeholder="Digite o e-mail da pessoa que você quer convidar..."
            required
          />
          <span
            v-if="isValidEmail !== 'true' && validateEmail(email)"
            class="text-alert-match-passwords"
            ><b>Usuário já se encontra na plataforma</b></span
          >
          <span
            v-else-if="isValidEmail === 'true' && validateEmail(email)"
            class="text-alert-valid-email"
            ><b>Email pode ser convidado.</b></span
          >

          <div class="d-flex justify-content-start align-items-center">
            <div>
              <label class="text-align-left" for="municipio">Municipio</label>
              <select
                v-model="municipioData"
                class="form-control"
                id="municipio"
                required
              >
                <option
                  v-for="municipio in municipios"
                  :key="municipio.nome"
                  :value="municipio.idmunicipio"
                >
                  {{ municipio.nome }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="button-div pt-2">
        <Button
          section="orange-outline"
          value="Convidar Membro"
          :isOutline="true"
          :hasIcon="true"
          iconName="paper-plane"
        />
      </div>
    </form>
  </div>
</template>

<script>
import Button from "../../components/Button";
import { Notyf } from "notyf";
const notyf = new Notyf({
  duration: 5000,
  position: {
    x: "left",
    y: "bottom",
  },
});

export default {
  name: "AddUserMunic",
  data() {
    return {
      email: "",
      municipioData: "",
      regional: '',
    };
  },
  async created() {


    /**
     * Obtém todas as cidades com base no estado selecionado
     */
    const loggedPerm = this.$store.getters.getUserPerm
    if(loggedPerm.id_permissao == 4) {
      await this.$store.dispatch("setUserMunicipios");
    } else if(loggedPerm.id_permissao == 5) {
      const payload = {
        id_regional: loggedPerm.id_regional
      };
      await this.$store.dispatch("setRegionalMunicipios", payload);
    } else if(loggedPerm.id_permissao == 6) {
      await this.$store.dispatch("setMunicipios");
    }
    
  },
  computed: {
    isValidEmail() {
      return this.$store.getters.getIsValidEmail;
    },

    /**
     * Retorna todas as municipios
     */
    municipios() {
      return this.$store.getters.getMunicipios;
    },

    getRegional() {
      return this.$store.getters.getRegional;
    },
  },
  methods: {
    validateEmail(email) {
      var re = /\S+@\S+\.\S+/;
      return re.test(email);
    },

    async verifyValidadeEmail() {
      if (this.validateEmail(this.email)) {
        await this.$store.dispatch("setIsValidEmail", this.email);
      }
    },

    async createMember() {
      // Testa o email
      if(!this.validateEmail(this.email)) {
        notyf.open({
          type: "error", message: "Email inválido.", });
        return;
      }
      // Verifica se o email já está cadastrado
      if (this.isValidEmail === "false") {
        notyf.open({
          type: "error", message: "Este email já está ligado a uma conta.", });
        return;
      }


      const payloadRegional = {
        id_municipio: this.municipioData,
      };
      await this.$store.dispatch("setRegionalByMunicipio", payloadRegional)
      // Registrando informações do payload

      // Sucesso
      notyf.open({
        type: "success", message: "Convite enviado com sucesso!", });
      this.email = "";

    },
  },

  components: {
    Button,
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  background-color: white;
}

.title-style {
  text-align: center;
  font-size: 1.5rem;
  font-weight: 600;
  color: #656565;
}

.question-style {
  width: 100%;
  font-size: 1rem;
  font-weight: 500;
  color: #656565;
}

.image-style {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
  padding: 1rem;
}

.button-div {
  text-align: right;
  display: flex;
  justify-content: space-around;
}

.text-alert-match-passwords {
  color: rgb(224, 53, 53);
  font-weight: 100;
  font-size: 0.9rem;
}

.text-alert-valid-email {
  color: rgb(104, 158, 60);
  font-weight: 100;
  font-size: 0.9rem;
}
</style>
